import styled from "styled-components"

export const Form = styled.form`
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/forms/withForm/styled.js